<script>
import {
    Doughnut
} from 'vue-chartjs'

export default {
    extends: Doughnut,
    props: ['ANC', 'AC'],
    mounted() {
        this.renderChart({
            labels: ['Ativo não corrente', 'Ativo corrente'],
            datasets: [
                {
                    data: [parseFloat((parseFloat(this.ANC)*100)/(parseFloat(this.ANC)+parseFloat(this.AC))).toFixed(0), parseFloat((parseFloat(this.AC)*100)/(parseFloat(this.ANC)+parseFloat(this.AC))).toFixed(0)],
                    backgroundColor: ['rgb(113, 206, 206, 0.5)', 'rgb(181, 143, 255, 0.5)'],
                    borderColor: ['rgb(113, 206, 206, 1)', 'rgb(181, 143, 255, 1)'],
                    borderWidth: 1,
                    borderAlign: 'inner'
                },
            ]
        }, {
            responsive: true,
            maintainAspectRatio: false,
            title: {
                display: true,
                text: 'Estrutura do Ativo',
                fontSize: 14
            }
        })
    }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/Chart6.vue